<template>
	<div class="px-5 pt-3 pb-2 mb-5 ResponsiveAudit page-fill">
		<div class="items-center justify-between flex">
			<div class="title flex items-center">
				<h1>Audit</h1>
			</div>
			<div class="flex items-center gap-3">
				<button :class="!isAddDisabled(10301)?'btndisabled pointer-events-none ':'btnprimary flex items-center btnPrimaryPadding'" @click="createNewAudit">Add</button>
				<button class="flex" @click="filterOpen" :class="tableRow.length == 0 ? 'btndisabled pointer-events-none' : 'filterButton'">
					<img v-if="tableRow.length == 0" src="@/assets/filterIcon_Disabled.svg" class="filterIcon"/>
					<img v-else src="@/assets/filter.svg" class="filterIcon" />
					Filters
				</button>
			</div>
		</div>
		<div class="mt-3">
			<p class="headerText">
				An audit is an independent and official examination of an organization's records, systems, or activities to check for accuracy, fairness, and legal compliance.
			</p>
		</div>
		<div class="table-section">
			<tableData class="flex-1 min-h-0" :tableRowData="tableRow" :headersData="headersTable" :loadData="dataLoading"></tableData>
			<div v-if="toolTipActive">
				<tool-tip :tipText="toolTipText"></tool-tip>
			</div>
		</div>
	</div>
</template>
<style scoped>
/* .btnPrimaryPadding{
	padding-left : 16px;
	padding-right : 16px;
} */
</style>
<script lang="ts">
import { defineComponent } from 'vue';
import _ from 'lodash';
import { required } from '@vuelidate/validators';
import tableData from '@/components/tableData.vue';
import useVuelidate from '@vuelidate/core';
import { mapGetters } from 'vuex';
import { emitter, toast } from '@/main';
import toolTip from '@/components/toolTip.vue'

export default defineComponent({
	data(): any {
		return { 
			v$: useVuelidate(),
			savedAuditSets: [],
			optionsUserArray: [],
			showFilters: false,
			selected: '',
			autoSuggestion: false,
			dummyList: [],
			dummyAuditObj: [],
			tableRow: [],
			optionUserArray:[],
			headersTable:['auditId','title','auditPeriod','startDate','endDate','auditor1','auditStatus','actionButtonAtAudits'],
			toolTipActive:false,
			toolTipText:'',
			dataLoading:true
		};
	},
	components: {
		tableData,
		toolTip
	},
	computed: {
		...mapGetters({ userInfo: 'userInfo' }),
		e: function (): any {
			return false;
		}
	},
	async mounted() {
		this.dataLoading = true;

		await this.getAllUsers()
		await this.getAuditSets();

		this.dataLoading = false;

		this.bindAuditTableListeners();
		emitter.off('detailsModalClosed', this.onDetailsModalClosed)
		emitter.on('detailsModalClosed', this.onDetailsModalClosed)

		emitter.off('activiteToolTip');
        emitter.on('activiteToolTip', (data: any) => {
            if (this.isDetailsModalOpen()) {
                return;
            }
            this.toolTipActive = true;
            this.toolTipText = data.tipText
        });
 
        emitter.off('deActiviteToolTip');
        emitter.on('deActiviteToolTip', (data: any) => {
            this.toolTipActive = false;
            this.toolTipText = ''
        });
	},
	beforeUnmount() {
		emitter.off('clickedOnTableRow', this.onAuditTableRowClick)
		emitter.off('clickedOnDropDownAction', this.onAuditDropDownAction)
		emitter.off('detailsModalClosed', this.onDetailsModalClosed)
	},
	methods: {
		isDetailsModalOpen() {
			return !!document.querySelector('.details-modal-overlay');
		},
		bindAuditTableListeners() {
			emitter.off('clickedOnTableRow')
			emitter.on('clickedOnTableRow', this.onAuditTableRowClick)
			emitter.off('clickedOnDropDownAction', this.onAuditDropDownAction)
			emitter.on('clickedOnDropDownAction', this.onAuditDropDownAction)
		},
		async onDetailsModalClosed() {
			this.bindAuditTableListeners();
			await this.refreshAfterDetailsModal();
		},
		onAuditTableRowClick(rowData:any){
			if(this.isDetailsModalOpen()){
				return;
			}
			this.toolTipActive = false;
			this.toolTipText = '';
			emitter.emit('deActiviteToolTip');
			this.$router.push({ name: 'view-audit', params: { auditId: rowData._id } });
		},
		async onAuditDropDownAction(actionObj:any){
			if(this.isDetailsModalOpen()){
				return;
			}
			await this.changeRouteForAction(actionObj.action,actionObj.data)
		},
		async refreshAfterDetailsModal() {
			this.tableRow = [];
			this.savedAuditSets = [];
			this.dummyList = [];
			await this.getAuditSets();
		},
		async changeRouteForAction(action:any,rowData:any){
			if(action=='Edit'){
				if(rowData.createdBy == this.userInfo._id){
					emitter.emit('openDetailsModal', {
						view: 'editAudit',
						title: rowData.title || 'Edit Audit',
						params: { auditId: rowData._id },
					});
				}else{
					toast.error('Cannot Edit', {
						timeout: 1000,
						closeOnClick: true,
						closeButton: 'button',
						icon: true
					});
				}			
			}else if(action=='Controls'){
				emitter.emit('openDetailsModal', {
					view: 'auditControls',
					title: rowData.title || 'Audit Controls',
					params: { auditId: rowData._id },
				});
			} else if(action == 'Start Audit'){
				emitter.emit('openDetailsModal', {
					view: 'startAudit',
					title: rowData.title || 'Start Audit',
					params: { auditId: rowData._id },
				});
			} else if(action == 'View'){
				this.$router.push({ name: 'view-audit', params: { auditId: rowData._id } });
			} 
		},
		filterOpen() {
			this.showFilters = !this.showFilters;
			if (this.showFilters == true) {
                this.dummyList = this.savedAuditSets;
            } else {
                this.savedAuditSets = this.dummyList;
            }
			emitter.emit('visible', this.showFilters);
		},
		createNewAudit() {
			emitter.emit('openDetailsModal', {
				view: 'createAudit',
				title: 'Create - Audit',
				params: {},
			});
		},
		isAddDisabled(permission:any) {
			try {
				if (!this.userInfo || !this.userInfo.organisationType) {
					return true;
				}
                if(this.userInfo.organisationType==10702 && this.userInfo.roleId==10216){
					return true;
				}
				// if (this.userInfo.organisationType !== 10701) {
				// 	return true; 
				// }
				return this.hasPermission(this.userInfo, 10006, 10120, permission);
			} catch (e) {
				return true;
			}
	  	},
		hasPermission(userInfo:any, appId:any, entityId:any, permissionId:any) {
			if (!userInfo || !userInfo.apps) return false;
			const app = userInfo.apps.find((a:any) => a.appId === appId);
			if (!app) return false;

			const entity = app.entities?.find((e:any) => e.entityId === entityId);
			if (!entity) return false;

			return entity.permissions?.includes(permissionId) || false;
		},
		async getAllUsers() {
			this.optionUserArray = []
			await this.$http.get(`${process.env.VUE_APP_ORG_API}/users/getAll`).then((res: any) => {
				for (var i = 0; i < res.data.length; i++) {
					this.optionUserArray.push({ label: res.data[i].name, value: res.data[i]._id });
				}
			});
		},
		changeDateFormat(date: any) {
			if (date.includes('-')) {
				let dateParts = date.split('-');
				if (dateParts.length === 6) {
				let startDate = `${dateParts[2]}/${dateParts[1]}/${dateParts[0]}`;
				let endDate = `${dateParts[5]}/${dateParts[4]}/${dateParts[3]}`;
				return `${startDate} - ${endDate}`;
				} else if (dateParts.length === 3) {
				return `${dateParts[2]}/${dateParts[1]}/${dateParts[0]}`;
				}
			}
			return date.split('-').reverse().join('/');
		},
		
		async getAuditSets() {
			this.savedAuditSets = [];

			await this.$http.get(`${process.env.VUE_APP_AUDIT_API}/api/org/audits/getAll`).then((result: any) => {
				result.data.forEach((info: any) => {
					this.savedAuditSets.push(info);
					this.dummyList.push(info);
				});
			})
			
			this.savedAuditSets.forEach((auditObj: any) => {
				// console.log('optionUserArray',this.optionUserArray)
				let findName = this.optionUserArray.find((obj:any)=>{return obj.value == auditObj.teamLeader});
				let auditPeriodFormat = `${this.changeDateFormat(auditObj.period.fromDate)} - ${this.changeDateFormat(auditObj.period.toDate)}`
				this.tableRow.push({
					_id: auditObj._id,
					auditId: auditObj.auditId != undefined ? auditObj.auditId : 'N/A',
					title: auditObj.title != undefined ? auditObj.title : 'N/A',
					startDate: auditObj.startDate != undefined ? auditObj.startDate : 'N/A',
					endDate : auditObj.endDate != undefined ? auditObj.endDate : 'N/A',
					auditPeriod: auditPeriodFormat != undefined ? auditPeriodFormat : 'N/A',
					auditor1: findName!=undefined? findName.label:'N/A',
					auditStatus: auditObj.statusCode != undefined ? auditObj.statusCode : 'N/A',
					createdBy: auditObj.createdBy != undefined ? auditObj.createdBy : 'N/A',
				});
			});
		}
	},
	async created() {
        // await this.getAuditSets();
		window.addEventListener('click', (e) => {
			this.autoSuggestion = false;
		});
	}
});
</script>
 